import { Component, Input, OnInit } from '@angular/core';
import { ModuleManager } from 'src/shared/models/module-manager';
import SlideoutSettingsManager from 'src/shared/models/slideout-settings-manager';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
    selector: 'cv-coaching-type-filter',
    templateUrl: './coaching-type-filter.component.html',
    styleUrls: ['./coaching-type-filter.component.scss']
})
export class CoachingTypeFilterComponent implements OnInit {

    @Input() moduleManager: ModuleManager;
    @Input() context: any;


    selectedFilter = { Values: { COACHING_SESSION_TYPE: [null] }, name: '' };
    state = { Values: { COACHING_SESSION_TYPE: [null] } };
    settingsManager: SlideoutSettingsManager;
    placeholder = "";
    coachDropDownOptions = [
        { Values: { COACHING_SESSION_TYPE: ['!#--DO NOT SEND FILTER--#!'] }, name: this.cvLocalizationService.getCachedText("Coaching_Status_Module", "All_Coaching_Types", "All Coaching Types"), id: 0 },
        { Values: { COACHING_SESSION_TYPE: ['Coach The Coach'] }, name: this.cvLocalizationService.getCachedText("Coaching_Status_Module", "Coach_the_Coach", "Coach the Coach"), id: 1 },
        { Values: { COACHING_SESSION_TYPE: ['Group'] }, name: this.cvLocalizationService.getCachedText("Coaching_Status_Module", "Group_Coaching", "Group Coaching"), id: 2 },
        { Values: { COACHING_SESSION_TYPE: ['1:1'] }, name: this.cvLocalizationService.getCachedText("Coaching_Status_Module", "One_One_Coaching", "1:1 Coaching"), id: 3 },
    ];

    constructor(private cvLocalizationService: CVLocalizationService) { }

    async ngOnInit(): Promise<void> {
        this.placeholder = this.cvLocalizationService.getCachedText("Coaching_Status_Module", "All_Coaching_Types", "All Coaching Types");
        this.selectedFilter = this.coachDropDownOptions[0];
        this.moduleManager.addState({
            name: 'reportFilterableFields',
            autoLoad: true,
            getStateData: () => this.state,
            onStateLoaded: (stateData) => {
                if (!stateData) {
                    this.selectedFilter = this.coachDropDownOptions[0];
                    this.coachingTypeSelect(false);
                    return;
                }
                this.selectedFilter = this.coachDropDownOptions.find(item => item.name === stateData.name)
                this.state = stateData;
            }
        });
        this.moduleManager.setOptions({
            onSettingsApplied: settings => {
                if (settings.reportFilterableFields) {
                    this.state.Values['COACHING_SESSION_STATUS'] = settings.reportFilterableFields.Values.COACHING_SESSION_STATUS;
                    this.moduleManager.previousStateValues['reportFilterableFields'] = null;
                    this.coachingTypeSelect(true);
                }
            }
        });
    }

    async coachingTypeSelect(isPublishNeeded: boolean) {
        if (!this.selectedFilter) {
            this.selectedFilter = this.coachDropDownOptions[0];
        }
        this.state.Values['COACHING_SESSION_TYPE'] = this.selectedFilter.Values['COACHING_SESSION_TYPE'];
        await this.moduleManager.saveState('reportFilterableFields');
        if (isPublishNeeded) {
            this.moduleManager.requestPublishNeeded();
        }
        this.moduleManager.slideoutSettingsManager.next(null);
    }
}
